module.exports = __webpack_public_path__ + "img/capturer-diplomat-3.805f34f8.svg";